/**
 * This enum is used to represent monitor activity type
 */
export enum MonitorActivityType {
  /**
   * The Click action type
   */
  Click = 'CLICK',

  /**
   * The Redirect action type
   */
  Redirect = 'REDIRECT',
}
